var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"item"},[_vm._m(0),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.brief))])]),_c('div',{staticClass:"item"},[_vm._m(1),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.target))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-head"},[_c('div',{staticClass:"dot-title"},[_vm._v("课程介绍")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-head"},[_c('div',{staticClass:"dot-title"},[_vm._v("课程目标")])])
}]

export { render, staticRenderFns }